import React from 'react';
import Navbar from '../../components/navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Hero from '../../components/hero/Hero';
import Socials from './components/Socials'; 
import News from './components/News'; 
import Catalogue from './components/Catalogue';
import AboutHero from './components/AboutHero';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <Navbar />
      <Hero />
      <main className="home-main">
        <News />
        <Socials />
        <Catalogue />
        <AboutHero />      
      </main>
      <Footer />
    </div>
  );
};

export default Home;